import React from 'react';

export default function IconCH() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 23">
            <path
                fill="#FF4B55"
                d="M31.449 22.31H.552A.56.56 0 0 1 0 21.741V1.26a.56.56 0 0 1 .552-.57H31.45a.56.56 0 0 1 .551.57V21.74a.56.56 0 0 1-.551.57Z"
            />
            <path
                fill="#F5F5F5"
                d="M22.07 9.224h-3.863V5.241a.56.56 0 0 0-.552-.569h-3.31a.56.56 0 0 0-.552.57v3.982H9.931a.56.56 0 0 0-.551.57v3.413a.56.56 0 0 0 .551.569h3.862v3.983a.56.56 0 0 0 .552.569h3.31a.56.56 0 0 0 .552-.57v-3.982h3.862a.56.56 0 0 0 .552-.57V9.794a.56.56 0 0 0-.552-.569Z"
            />
        </svg>
    );
}
